import { Alert, Text } from "@/atoms"
import { DisconnectOutlined } from "@/icons"
import {
  ConfigItem,
  FooterConfigItem
} from "@/pages/IntegrationsPage/components/molecules/ConfigItem"
import { FormAcr } from "@/pages/IntegrationsPage/components/molecules/FormAcr"
import { useAcrAPI } from "@/pages/IntegrationsPage/hooks/useAcrAPI"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { INTEGRATIONS_WRITE_PERMISSION } from "@/pages/IntegrationsPage/IntegrationsPage.constants"

import styles from "./AcrConfigurationPage.module.scss"

import type { AcrConfigurationItemProps } from "."

export const AcrConfigurationItem = (props: AcrConfigurationItemProps) => {
  const { registry, vendor } = props
  const [_, { onRemove, ...actions }] = useIntegration({ vendor })
  const { t } = actions
  const acrApi = useAcrAPI({ registry, ...actions })
  const { registryUrl, repositories, clientId, health } = registry
  const showHealth = !!health && health.status !== "healthy"

  return (
    <ConfigItem
      values={{ id: registryUrl, name: registryUrl, health }}
      Description={
        <Text type="secondary">
          {[
            t("integrations.acr.baseImagesCount", {
              count: repositories.length
            }),
            clientId ? t("integrations.acr.identity", { clientId }) : null
          ]
            .filter(Boolean)
            .join(" · ")}
        </Text>
      }
    >
      <div className={styles.body}>
        {showHealth && health.message && (
          <Alert
            showIcon
            type={health.status === "unhealthy" ? "error" : "warning"}
            title={health.message}
          />
        )}
        <FormAcr
          formId={acrApi.formId}
          registry={registry}
          onFinish={acrApi.onFinish}
          {...actions}
        />
      </div>
      <FooterConfigItem
        formId={acrApi.formId}
        isDirty={actions.isDirty}
        isPending={acrApi.isPending || actions.isPending}
        permissions={INTEGRATIONS_WRITE_PERMISSION}
        removeTKey="general.disconnect"
        RemoveIcon={DisconnectOutlined}
        onRemove={() => onRemove({ id: registryUrl, name: registryUrl })}
        onReset={actions.onReset}
      />
    </ConfigItem>
  )
}
